import axios from "axios";
import Config from "../../../config";

const v2_actionEditarCustomField = (fieldId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/custom-fields/${fieldId}/editar`,
        data
    });
};

export default v2_actionEditarCustomField;
